import { render, staticRenderFns } from "./PageEducatorClassroomEdit.vue?vue&type=template&id=b55e4c4e&scoped=true&"
import script from "./PageEducatorClassroomEdit.vue?vue&type=script&lang=js&"
export * from "./PageEducatorClassroomEdit.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorClassroomEdit.vue?vue&type=style&index=0&id=b55e4c4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55e4c4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VForm,VRow})
